<script lang="ts" setup>
const { LocalConfigurationStore } = stores()
const heading = computed(() => LocalConfigurationStore.value?.siteInfo?.companySectionTitle)
const items = computed(() => LocalConfigurationStore.value?.associatedCompanies)

const companyLogosIds = computed(
  () => LocalConfigurationStore.value?.associatedCompanies?.map((c) => `${c.code}-logo`) ?? []
)

const { allCompleted } = useImageLoaderTracker(companyLogosIds)

const isReady = computed(() => allCompleted.value)
</script>

<template>
  <div class="flex flex-col gap-1">
    <TitleComponent
      v-if="heading"
      :text="heading.title"
      :tagline="heading?.subTitle"
    />
    <GridComponent :cols="items?.length">
      <div
        v-for="company in items"
        :key="company.code"
      >
        <PvSkeleton
          v-if="!isReady"
          class="aspect-[17/9] w-full"
        />
        <ClientOnly>
          <ContentCompanyThumbnail
            v-show="isReady"
            :id="`${company.code}-logo`"
            :src="getCompanyLogo(company?.logoWhiteUrl)"
          />
        </ClientOnly>
      </div>
    </GridComponent>
  </div>
</template>
